<template>
	<div>
		<div v-if="inPrint == -1">
			<div class="tips" v-if="printer_err == ''">
				<el-alert title="正在链接打印代理..." type="info" :closable="false"> </el-alert>
			</div>
			<div class="tips" v-else>
				<el-alert :title="printer_err" type="error" :closable="false"> </el-alert>
			</div>

			<div class="row">
				<div class="col-6">
					<h3 class="mt-3">安装代理软件</h3>
					<a href="https://www.neodynamic.com/downloads/jspm/" target="_blank"
						>下载打印代理软件</a
					>
					<div class="tips">
						如果已经安装，注意启动。
					</div>
				</div>
				<div class="col-6">
					<h3 class="mt-3">选择打印机</h3>
					<el-select size="small" v-model="selected_printer" placeholder="选择打印机">
						<el-option
							v-for="printer in printers"
							:key="printer"
							:label="printer"
							:value="printer"
						>
						</el-option>
					</el-select>
					<div class="tips">选中：{{ selected_printer }}</div>
					<el-button size type="success" @click="handleChoosePrinter()">确定</el-button>
				</div>
			</div>
		</div>
		<div class="d-print-none" v-else>
			<el-button size type="success" @click="doPrintZPL()">打印</el-button>
		</div>
		<div class="row">
			<template class="a-page" v-for="item in items">
				<div v-for="amount in item.amount" :key="amount" class="col-3 mt-3">
					<div>PD{{ item._id }}</div>
					<div
						>{{ item.brand.name }} - {{ item.brand_show_id }} -
						{{ item.product_color.color_code }}</div
					>
					<div>{{ item.model.name === '均码' ? 'U': item.model.name}} RMB {{ item.product_color.price_6 }}</div>
				</div>
			</template>
		</div>
	</div>
</template>
<script>
import Order from "@/mixinsApp/Order.js";
import TxOp from "@/mixinsApp/TxOp.js";
import { mapState, mapGetters, mapMutations } from "vuex";
import JSPM from "jsprintmanager";

export default {
	mixins: [Order, TxOp],
	config: {
		adminFilter: [
			{
				k: "is_leave",
				t: "bool",
				v: 0,
			},
			{
				k: "is_saler",
				t: "bool",
				v: 1,
			},
		],
	},
	data() {
		return {
			inPrint: -1,
			printers: [],
			selected_printer: "",
			printer_err: "",
		};
	},
	computed: {
		...mapState(["userPrivilegeMapping"]),
	},

	props: {
		items:  {
			type: Array,
			default: ()=> {
				return [];
			},
		},
	},
	created() {
		this.onInit();
	},
	mounted() {
		let externalScript = document.createElement("script");
		externalScript.setAttribute("src", "https://cdn.jsdelivr.net/gh/gildas-lormeau/zip.js/dist/zip-full.min.js");
		document.head.appendChild(externalScript);
	},
	methods: {
		onInit() {
			JSPM.JSPrintManager.auto_reconnect = true;
			JSPM.JSPrintManager.start();
			JSPM.JSPrintManager.WS.onStatusChanged = status => {
				console.log(status);
				this.getPrinters().then(p => {
					this.printers = p;
					this.$nextTick();
				});
			};
			JSPM.JSPrintManager.WS.onError = err => {
				debugger;
				console.error(err);
			};
		},
		getPrinters() {
			return new Promise((ok, err) => {
				let printers = [];
				if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open) {
					JSPM.JSPrintManager.getPrinters()
						.then(function(myPrinters) {
							printers = myPrinters;
							console.log(printers);
							ok(printers);
						})
						.catch(e => err(e));
				} else {
					console.warn("JSPM WS not open");
					this.printer_err = "连接失败";
					ok(printers);
				}
			});
		},
		handleChoosePrinter() {
			if (this.selected_printer) {
				this.inPrint = 0;
			}
		},
		_getZPL(item) {
// 			return `^XA
// ^PW479
// ^LL319

// ^FO20,40
// ^B3N,,100
// ^BY1,1
// ^FDPD${item._id}^FS 

// ^FO0,180
// ^A0,24,24
// ^FB479,1,0,C
// ^FD${item.brand.name} - ${item.brand_show_id} - ${item.product_color.color_code}\\&^FS 

// ^FO20,250
// ^A0,32,32
// ^FB479,1,0,L
// ^FD${item.model.name}^FS 

// ^FO0,250
// ^A0,32,32
// ^FB459,1,0,R
// ^FDRMB ${item.product_color.price_1}^FS 

// ^XZ`;
			return `^XA
^PW479
^LL319

^FO20,40
^BQ,2,5
^FDHA,PD${item._id}^FS

^FO20,230
^A0,24,24
^FB479,1,0,L
^FD${item.brand.name}^FS 

^FO20,270
^A0,24,24
^FB479,1,0,L
^FD${item.brand_show_id} - ${item.product_color.color_code}^FS 

^FO0,50
^A0,80,80
^FB359,1,0,R
^FD${item.model.name === '均码' ? 'U': item.model.name}^FS

^FO0,230
^A0,32,32
^FB410,1,0,R
^FDRMB ${item.product_color.price_6}^FS

^XZ`;
		},
		doPrintZPL() {
			if (this.selected_printer === "" && !this.print2default) {
				alert("You must select a printer");
				return;
			}
			let cpj = new JSPM.ClientPrintJob();
			cpj.clientPrinter = new JSPM.InstalledPrinter(this.selected_printer);

			const cmds = [];
			for (const item of this.items) {
				for (let i = 0; i < item.amount; i++) {
					cmds.push(this._getZPL(item));
				}
			}

			cpj.printerCommands = cmds.join("\n");
			debugger;
			cpj.sendToClient();
		},
		handleOrderEdited(key) {},
		doResetAll() {
			// this.initInfo();
		},
		gotoPrint() {
			this.inPrint = 1;
		},
	},
};
</script>
<style>
.el-radio-button--mini .el-radio-button__inner {
	padding: 7px 7px;
}


</style>
